import React from 'react'

export default function Skeleton1() {
    return (
        <div className="skeleton-featured skeleton">
            <div className="skeleton-featured-content">
                <div className="skeleton-title"></div>
                <div className="skeleton-buttons">
                    <div className="skeleton-button"></div>
                    <div className="skeleton-icon"></div>
                </div>
                <div className="skeleton-subtitle"></div>
            </div>
        </div>

    )
}
